var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Back(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5081 22.3392C17.7741 22.6036 17.7754 23.0336 17.511 23.2996C17.2466 23.5656 16.8166 23.567 16.5506 23.3026L11.6999 18.4812C11.5716 18.3537 11.4995 18.1804 11.4995 17.9995C11.4995 17.8187 11.5716 17.6454 11.6999 17.5179L16.5506 12.6965C16.8166 12.4321 17.2466 12.4335 17.511 12.6995C17.7754 12.9655 17.7741 13.3955 17.5081 13.6599L13.8252 17.3204L23.8204 17.3204C24.1954 17.3204 24.4995 17.6245 24.4995 17.9995C24.4995 18.3746 24.1954 18.6786 23.8204 18.6786L13.8252 18.6786L17.5081 22.3392Z",
    fill: "#474749"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Back);
export default __webpack_public_path__ + "static/media/100-back.156ff7fe367c090112e0298347f2f3f8.svg";
export { ForwardRef as ReactComponent };